import * as types from "../../mutation-types";

const state = {
  report: [],
  hasNotificationFromReport: false,
  componentLoading: false,
};

const mutations = {
  [types.LOADING_REPORT](state, payload) {
    state.componentLoading = payload;
  },
  [types.REPORT](state, payload) {
    state.report = payload;
  },
  [types.NOTI_REPORT](state, payload) {
    state.hasNotificationFromReport = payload;
  },
};

export default {
  state,
  mutations,
};
